export default "__VITE_ASSET__CQlh77IC__"